import type { TopicResponse } from "@redotech/effect-api-shared/rpc/topic";
import { useRequiredContext } from "@redotech/react-util/context";
import { EffectApiClientContext } from "@redotech/redo-merchant-app-common/effect-api-client-provider";
import { useQuery } from "@tanstack/react-query";
import { catchApiErrorsSilent } from "../../db/error-handling";
import { topicKeys } from "./topic-keys";

export function useTopics(): {
  topics: readonly TopicResponse[];
  isLoading: boolean;
  refetch: () => void;
} {
  const effectApi = useRequiredContext(EffectApiClientContext);

  const query = useQuery({
    queryKey: topicKeys.list(),
    queryFn: async () => {
      const client = effectApi.getClient();
      return await effectApi.runPromise(
        catchApiErrorsSilent(client.topic.listTopics()),
      );
    },
    staleTime: 60_000,
    meta: { showErrorToast: true },
  });

  return {
    topics: query.data?.topics ?? [],
    isLoading: query.isLoading,
    refetch: () => {
      void query.refetch();
    },
  };
}
